// Core
import React, { useState, useEffect } from "react";

// Components - Contrib
import { Button, Container, Row, Col, Card } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";

// Components - Custom
import { searchFAQcontent } from "../data/apis";
import { excerptHighlight } from "../assets/utilities";

import loader from "../assets/loading.gif";

function SearchResults() {
	const [searchedContent, searchContent] = useState();
	let { subjectAreaID, searchQuery } = useParams();

	const navigate = useNavigate();

	let query = (subjectAreaID ? subjectAreaID + "/" : "") + searchQuery;
	console.log(query);

	useEffect(() => {
		(async () => {
			var data = await searchFAQcontent(query);
			searchContent(data);
		})();
	}, [query]);

	if (!searchedContent) {
		return (
			<div className="loader">
				<img src={loader} alt="loader" />
			</div>
		);
	}

	console.log(searchedContent);

	if (searchedContent.questions.length === 0)
		return (
			<Container className="searchResults p-0" fluid>
				<Row>
					<Col xs={12}>
						<hr className="mb-5" />
						<div className="d-flex justify-content-between">
							<span>
								Sorry no results found for: <i>"{searchQuery}"</i>
							</span>
							<Button variant="link" onClick={() => navigate(-1)}>
								Search Again
							</Button>
						</div>
						<hr className="my-5" />
					</Col>
				</Row>
			</Container>
		);

	const subject_area = searchedContent.questions[0].reverse_question[0];

	return (
		<Container className="searchResults p-0" fluid>
			<Row>
				<Col xs={12}>
					<hr className="mb-5" />
					<div className="d-flex justify-content-between">
						<span>
							Displaying {searchedContent.questions.length} results for: <i>"{searchQuery}"</i>
						</span>

						{subjectAreaID ? <Link to={subject_area.subject_url.split("#")[1]}> Back to: {subject_area.Display}</Link> : <Link to={"/"}>Back to all FAQs</Link>}
					</div>

					<hr className="my-5" />
					{searchedContent.questions.map((item, i) => {
						if (item.reverse_question.length > 0) {
							var question = excerptHighlight(item.Question, searchQuery);
							var answer = excerptHighlight(item.Answer, searchQuery);
							var meta = item.reverse_question[0];
							var anchor = "?anchor=" + meta.questionID;
							var url = meta.subject_url.replace("/#", "") + anchor;

							return (
								<Card key={i} className="mb-4">
									<Card.Header>
										<Link to={url}>
											<span dangerouslySetInnerHTML={{ __html: question }}></span>
										</Link>
									</Card.Header>
									<Card.Body>
										<p dangerouslySetInnerHTML={{ __html: answer }}></p>
									</Card.Body>
								</Card>
							);
						} else {
							return null;
						}
					})}
				</Col>
			</Row>
		</Container>
	);
}

export default SearchResults;
